import { useEffect, useLayoutEffect } from 'react';
/**
 * "In the browser, `useLayoutEffect`, but in SSR, `useEffect`.",
 */
export var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
